<n-slide-window *ngIf="pageReady"
    [visible]="windowVisible"
    [width]="slideWindowWidth"
    [showMask]="false"
    [outClickHide]="true"
    (onHide)="close()">
    <n-header>
        <h1 nTextTips>{{data.NAME}}</h1>
        <n-help-link key="cifsView" *ngIf = "!SWITCH.IS_SIMPLE_MODE"></n-help-link>
        <n-help-link key="simplifycifsManage" *ngIf="SWITCH.IS_SIMPLE_MODE"></n-help-link>
        <n-split-button class="ml-auto" id="cifs_detail_action_btn" [label]="i18n.btn.actionBtn" [items]="operationBtns"
            [simpleMode]="SWITCH.IS_SIMPLE_MODE">
        </n-split-button>
    </n-header>

    <n-block [title]="i18n.title.basicInfo">
        <n-lv [colcount]="2" [simpleMode]="SWITCH.IS_SIMPLE_MODE">
            <!-- 共享名称 -->
            <n-lv-item [label]="i18n.label.share_name">
                <span class="text-wrap">{{data.NAME}}</span>
            </n-lv-item>
            <!-- 所属租户 -->
            <n-lv-item [label]="i18n.label.vStoreLab" *ngIf="!isSimpleMode">
                <span>{{data.vstoreName || UNPLACEHOLDER}}</span>
            </n-lv-item>
            <!-- 共享路径， 如果是homedir 显示相对路基 -->
            <n-lv-item [label]="data.subType === ShareTypeE.Homedir ? i18n.label.relative_path : i18n.label.share_path">
                <span class="text-wrap">{{data.SHAREPATH}}</span>
            </n-lv-item>
            <!-- homedir -->
            <n-lv-item [label]="i18n.label.homedir">
                <span>{{data.subType === ShareTypeE.Homedir ? i18n.value.yes : i18n.value.no}}</span>
            </n-lv-item>
            <!-- notify -->
            <n-lv-item [label]="i18n.label.notify">
                <span>{{data.ENABLENOTIFY === 'true' ? i18n.label.enabled : i18n.label.disable}}</span>
            </n-lv-item>
            <!-- 是否启用CA -->
            <n-lv-item [label]="i18n.label.enableCa">
                <span>{{data.ENABLECA === 'true' ? i18n.label.enabled : i18n.label.disable}}</span>
            </n-lv-item>
            <!-- 是否启用SMB3加密 -->
            <n-lv-item [label]="i18n.label.smb3EncryptionEnable">
                <span>{{str.renderEnable(data.smb3EncryptionEnable)}}</span>
            </n-lv-item>
            <!-- 是否启用拒绝非加密客户端访问 -->
            <n-lv-item [label]="i18n.label.unencryptedAccess">
                <span>{{str.renderEnable(data.unencryptedAccess)}}</span>
            </n-lv-item>
            <!-- 是否启用ABE -->
            <n-lv-item [label]="i18n.label.ABE">
                <span>{{data.ABEENABLE === 'true' ? i18n.label.enabled : i18n.label.disable}}</span>
            </n-lv-item>
            <!-- 显示以前的版本 -->
            <n-lv-item [label]="i18n.label.showPreviousVersion">
                <span>{{data.ENABLESHOWPREVIOUSVERSIONS === 'true' ? i18n.label.enabled : i18n.label.disable}}</span>
            </n-lv-item>
            <!-- 显示Snapshot -->
            <n-lv-item [label]="i18n.label.showSnapShotLab">
                <span>{{utilService.getLabelFromOptions | fn :enableShowSnapOpts :data.ENABLESHOWSNAPSHOT}}</span>
            </n-lv-item>
            <!-- 离线文件缓存模式 -->
            <n-lv-item [label]="i18n.label.offlineCacheModeLab">
                <span>{{utilService.getLabelFromOptions | fn :fileModeOpts :data.OFFLINEFILEMODE}}</span>
            </n-lv-item>
            <!-- 描述 -->
            <n-lv-item [label]="i18n.label.description" [colspan]="2">
                <span class="text-wrap">{{utilService.decodeHTML | fn :data.DESCRIPTION || UNPLACEHOLDER}}</span>
            </n-lv-item>
        </n-lv>
    </n-block>

    <!-- 极简模式只显示"权限" -->
    <n-block [title]="i18n.title.permissionList" *ngIf="isSimpleMode">
        <ng-container [ngTemplateOutlet]="addClients"></ng-container>
    </n-block>

    <!-- 标准模式显示tab -->
    <n-tab class="mt-20" [(activeItem)]="activeTab" *ngIf="!isSimpleMode">
        <n-tab-item [header]="i18n.title.permissionList">
            <ng-container [ngTemplateOutlet]="addClients"></ng-container>
        </n-tab-item>
        <n-tab-item *ngIf="data.subType === ShareTypeE.Homedir"
            [header]="i18n.title.mappingRule">
            <ng-template nTemplate>
                <div class="homedir-tab">
                    <p class="homedir-tab-des mb-10" style="margin-top: -0.1rem;">{{i18n.tip.mappingRule}}</p>
                    <app-homedir-rule-cifs-share class="feature-container" #homedirRuleDt [cifsShare]="data"></app-homedir-rule-cifs-share>
                </div>
            </ng-template>
        </n-tab-item>
        <n-tab-item [header]="i18n.title.extensionFiltering" *ngIf="!ProductConfig.isHideCifsFileFiltering">
            <ng-template nTemplate>
                <div class="homedir-tab">
                    <app-extension-filtering #extensionFilteringDt
                        class="feature-container"
                        [share]="data"
                        [shareType]="ShareMoTypeE.CIFS">
                    </app-extension-filtering>
                </div>
            </ng-template>
        </n-tab-item>
        <n-tab-item [header]="i18n.title.ipWhiteList">
            <ng-template nTemplate>
                <div class="homedir-tab">
                    <app-ip-white-list #ipWhiteListDt
                        class="feature-container"
                        [cifsData]="data">
                    </app-ip-white-list>
                </div>
            </ng-template>
        </n-tab-item>
    </n-tab>

    <n-footer>
        <button nButton [label]="i18n.btn.closeBtn" (click)="hide()">
        </button>
    </n-footer>
</n-slide-window>

<ng-template #addClients>
    <div class="homedir-tab">
        <p class="homedir-tab-des mb-10" style="margin-top: -0.1rem;">{{i18n.tip.clientsTip}}</p>
        <app-client-cifs-share class="feature-container" #clientDt [cifsShare]="data" [entry]="entry" [fileSystem]="fileSystem"></app-client-cifs-share>
    </div>
</ng-template>
